import Vue from 'vue'
import Vuex from 'vuex'
import moment from 'moment-hijri'
require('moment-precise-range-plugin')

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    version: process.env.VUE_APP_VERSION,
    server: '',
    license: '',
    noLicense: true,
    licenseNotMatch: false,
    setting:{},
    clock: moment(),  
    hijriClock: moment(),
    todayPraytime:[],
    holidays:[],
    hijriTurnover:0,    
  },

  mutations: {    
    clock(state){
      state.clock = moment()
      state.hijriClock = moment().add(state.hijriTurnover, 'minutes').add(state.setting.hijri_correction, 'days')
    },    
    hijriTurnover(state, value){
      state.hijriTurnover = value
    },
    server (state, value) {
      state.server = value
    },
    license(state, value){
      state.license = value
    },
    noLicense(state, value){
      state.noLicense = value
    },
    licenseNotMatch(state, value){
      state.licenseNotMatch = value
    },
    setting(state, value){
    state.setting = value
    },
    todayPraytime(state,value){
      state.todayPraytime = value
    },
    holidays(state,value){
      state.holidays = value
    },
  },
  
  actions: {  
  },

  getters:{
    prevPraytime(state){
      let p = state.todayPraytime.filter(item=> moment().isAfter(moment(item.time)) && item.slug != 'syuruq' && item.slug != 'imsyak')
      return p[p.length-1]
    },

    nextPraytime(state){
      let n = state.todayPraytime.filter(item => moment().isBefore(moment(item.time)) && item.slug != 'syuruq' && item.slug != 'imsyak')
      .sort((a,b)=> a.time - b.time )
      return n[0]
    },

    prevHoliday(state){
      var ph = state.holidays.filter(item=>{
        return state.hijriClock.isAfter(item.masehiFromHijri)
      }).sort((a,b)=>{
        return a.masehiFromHijri - b.masehiFromHijri
      })      
      return ph[ph.length-1]      
    },

    nextHoliday(state){
      var nh = state.holidays.filter(item=>{
        return state.hijriClock.isBefore(item.masehiFromHijri)
      }).sort((a,b)=>{
        return a.masehiFromHijri - b.masehiFromHijri
      })
      return nh[0]
    },

    generatedTimer(state, getters){
      if(getters.prevPraytime && getters.nextPraytime){        
        var toward = moment().preciseDiff(moment(getters.nextPraytime.time), true)        
        var iqomahCounter = moment().preciseDiff(moment(getters.prevPraytime.time).add(getters.prevPraytime.counter_iqomah, 'minutes'), state.clock, true)        
        return { toward, iqomahCounter }
      }
    },

    toIqomah(state, getters){
      if(getters.prevPraytime){   
        return (state.clock.isSameOrAfter(moment(getters.prevPraytime.time)) && state.clock.isBefore(moment(getters.prevPraytime.time).add(getters.prevPraytime.counter_iqomah, 'minutes')) ) ? true : false
      }
    },    

  }
})